export const notificationTitles = {
  skippaymentadmin: "رد شدن از پرداخت",
  successpaymentadmin: "پرداخت موفق",
  roadmapreadyadmin: "انتشار نقشه راه",
  completeanswersadmin: "تکمیل پاسخنامه",
};

export const notificationTitle = (key) => notificationTitles[key] || key || "";

const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
const arabicDigits = "٠١٢٣٤٥٦٧٨٩";

const toAsciiDigits = (value) =>
  String(value).replace(/[۰-۹٠-٩]/g, (char) => {
    const persian = persianDigits.indexOf(char);
    if (persian >= 0) return String(persian);
    const arabic = arabicDigits.indexOf(char);
    return arabic >= 0 ? String(arabic) : char;
  });

export const canonicalIranMobile = (raw) => {
  if (typeof raw !== "string") return null;
  let digits = toAsciiDigits(raw).replace(/\D/g, "");
  if (digits.startsWith("0098")) digits = digits.slice(4);
  else if (digits.startsWith("98") && digits.length === 12) digits = digits.slice(2);
  if (digits.length === 10 && digits.startsWith("9")) digits = "0" + digits;
  return /^09\d{9}$/.test(digits) ? digits : null;
};

export const normalizeReceiverList = (values) => {
  const mobiles = [];
  for (const value of values) {
    if (typeof value !== "string" || !value.trim()) continue;
    const mobile = canonicalIranMobile(value);
    if (!mobile) {
      return { error: "شماره موبایل معتبر نیست: " + value.trim() };
    }
    if (mobiles.includes(mobile)) {
      return { error: "شماره تکراری است: " + mobile };
    }
    mobiles.push(mobile);
  }
  if (mobiles.length > 30) {
    return { error: "حداکثر ۳۰ گیرنده می‌توانید ثبت کنید." };
  }
  return { mobiles };
};
